import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.analysis');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-analysis',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.analysis/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f5f7f4;
  color: #17202a;
}

.page-wrap {
  max-width: 1360px;
  margin: 0 auto;
  padding: 34px 28px 56px;
}

.work-header,
.filter-panel,
.table-panel,
.modal-panel {
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 44px rgba(23, 32, 42, 0.06);
}

.work-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 28px;
}

.header-copy h1 {
  margin: 6px 0 8px;
  font-size: 30px;
  font-weight: 850;
  letter-spacing: 0;
}

.header-copy p {
  margin: 0;
  max-width: 720px;
  color: #657069;
  line-height: 1.65;
}

.eyebrow,
.section-kicker,
.metric-card .label {
  color: #b28921;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0;
  text-transform: uppercase;
}

button {
  font: inherit;
}

.secondary-btn,
.primary-btn,
.text-btn,
.filter-chip,
.table-btn,
.page-btn,
.icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.16s ease;
}

.secondary-btn,
.primary-btn {
  min-height: 42px;
  padding: 0 15px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #26313d;
  font-weight: 850;
}

.primary-btn {
  border-color: #10375c;
  background: #10375c;
  color: #fff;
}

.secondary-btn:hover,
.table-btn:hover,
.page-btn:hover {
  border-color: #10375c;
  color: #10375c;
}

.secondary-btn:disabled,
.primary-btn:disabled,
.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.text-btn {
  border: 0;
  background: transparent;
  color: #10375c;
  font-size: 13px;
  font-weight: 850;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.metric-card {
  padding: 18px;
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #fff;
}

.metric-card strong {
  display: block;
  margin-top: 10px;
  color: #10375c;
  font-size: 27px;
  font-weight: 850;
}

.metric-card small {
  color: #737e77;
}

.filter-panel,
.table-panel {
  margin-top: 18px;
  overflow: hidden;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px;
  border-bottom: 1px solid #e5e8e2;
}

.panel-title h2,
.modal-title h2 {
  margin: 4px 0 0;
  font-size: 20px;
  font-weight: 850;
}

.panel-meta {
  color: #68736d;
  font-size: 13px;
  font-weight: 850;
}

.filter-block {
  display: grid;
  gap: 10px;
  padding: 18px 22px 0;
}

.filter-block:last-child {
  padding-bottom: 22px;
}

.filter-label {
  color: #3b4652;
  font-size: 13px;
  font-weight: 850;
}

.filter-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.filter-chip {
  min-height: 36px;
  padding: 0 12px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #4d5751;
  font-size: 13px;
  font-weight: 850;
}

.filter-chip em {
  min-width: 22px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #eef0ed;
  color: #68736d;
  font-style: normal;
  font-size: 11px;
}

.filter-chip.is-active {
  border-color: #10375c;
  background: #eaf2ff;
  color: #10375c;
}

.filter-chip.is-active em {
  background: #10375c;
  color: #fff;
}

.table-wrap {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  min-width: 1060px;
  border-collapse: collapse;
}

.data-table th {
  padding: 13px 18px;
  background: #f2f4f1;
  color: #657069;
  font-size: 12px;
  font-weight: 850;
  text-align: left;
}

.data-table td {
  padding: 16px 18px;
  border-top: 1px solid #edf0eb;
  vertical-align: middle;
}

.data-table tbody tr {
  cursor: pointer;
}

.data-table tbody tr:hover {
  background: #fbfcfa;
}

.title-cell {
  min-width: 380px;
}

.title-cell strong {
  display: block;
  color: #17202a;
  font-weight: 850;
  line-height: 1.45;
}

.title-cell span,
.date-text {
  display: block;
  margin-top: 4px;
  color: #88928c;
  font-size: 12px;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef0ed;
  color: #626b66;
  font-size: 12px;
  font-weight: 850;
}

.status-badge.is-done {
  background: #e9f7ef;
  color: #14754e;
}

.status-badge.is-progress {
  background: #eaf2ff;
  color: #1c5d99;
}

.status-badge.is-partial {
  background: #fff2d6;
  color: #93680d;
}

.doc-progress,
.deadline {
  color: #10375c;
  font-weight: 850;
}

.action-cell {
  display: flex;
  gap: 8px;
}

.table-btn {
  min-height: 34px;
  padding: 0 11px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #4c5751;
  font-size: 13px;
  font-weight: 850;
}

.table-btn.danger {
  width: 34px;
  padding: 0;
  color: #aa3a31;
}

.loading-state,
.empty-state {
  display: grid;
  place-items: center;
  gap: 12px;
  min-height: 280px;
  padding: 36px;
  color: #717b75;
  text-align: center;
}

.empty-state i {
  color: #b7beb7;
  font-size: 34px;
}

.empty-state strong {
  color: #17202a;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
}

.spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #dfe3db;
  border-top-color: #10375c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 18px 22px 22px;
  border-top: 1px solid #edf0eb;
}

.page-btn {
  min-width: 36px;
  height: 36px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #4d5751;
  font-weight: 850;
}

.page-btn.is-active {
  border-color: #10375c;
  background: #10375c;
  color: #fff;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(15, 22, 31, 0.42);
}

.modal-panel {
  width: min(660px, 100%);
  overflow: hidden;
}

.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 24px;
  border-bottom: 1px solid #e4e7e1;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border: 1px solid #d8ded6;
  background: #fff;
  color: #657069;
}

.form-grid {
  display: grid;
  gap: 14px;
  padding: 24px;
}

.two-col {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.field {
  display: grid;
  gap: 8px;
  color: #2c3642;
  font-size: 13px;
  font-weight: 850;
}

.field input {
  width: 100%;
  height: 44px;
  padding: 0 13px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  outline: none;
}

.field input:focus {
  border-color: #10375c;
}

.file-drop {
  display: grid;
  place-items: center;
  gap: 7px;
  min-height: 150px;
  padding: 22px;
  border: 1px dashed #b9c2b9;
  border-radius: 8px;
  background: #fbfcfa;
  color: #66716a;
  text-align: center;
  cursor: pointer;
}

.file-drop input {
  display: none;
}

.file-drop i {
  color: #0f6b57;
  font-size: 27px;
}

.file-drop strong {
  color: #17202a;
}

.file-drop em {
  color: #0f6b57;
  font-style: normal;
  font-weight: 850;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 18px 24px 24px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 980px) {
  .page-wrap {
    padding: 20px 14px 40px;
  }
  .work-header,
  .panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .metric-grid,
  .two-col {
    grid-template-columns: 1fr;
  }
  .modal-actions {
    flex-wrap: wrap;
  }
}
/* Library-tone compact overrides */
:host {
  background: #fafafa;
  color: #18181b;
}

.page-wrap {
  max-width: 1400px;
  padding: 20px 24px 60px;
}

.work-header {
  align-items: flex-start;
  padding: 0 0 12px;
  margin-bottom: 16px;
  border: 0;
  border-bottom: 1px solid #e4e4e7;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.header-copy h1 {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
}

.header-copy p {
  max-width: none;
  font-size: 12px;
  line-height: 1.45;
  color: #71717a;
}

.eyebrow,
.section-kicker,
.metric-card .label {
  color: #0f766e;
  font-size: 11px;
  font-weight: 650;
  text-transform: none;
}

.secondary-btn,
.primary-btn,
.text-btn,
.filter-chip,
.table-btn,
.page-btn,
.icon-btn {
  min-height: 32px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
}

.primary-btn {
  border-color: #0f766e;
  background: #0f766e;
}

.secondary-btn,
.table-btn,
.page-btn,
.icon-btn {
  border-color: #e4e4e7;
}

.secondary-btn:hover,
.table-btn:hover,
.page-btn:hover,
.icon-btn:hover {
  border-color: #99f6e4;
  color: #0f766e;
  background: #ecfdf5;
}

.text-btn {
  color: #0f766e;
}

.metric-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 0;
  margin-bottom: 12px;
}

.metric-card {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 0 10px;
  border-color: #e4e4e7;
  border-radius: 999px;
  background: #f4f4f5;
}

.metric-card strong {
  display: inline;
  margin: 0;
  color: #52525b;
  font-size: 11px;
  font-weight: 700;
}

.metric-card small {
  display: none;
}

.filter-panel,
.table-panel,
.modal-panel {
  margin-top: 12px;
  border-color: #e4e4e7;
  box-shadow: none;
}

.panel-head,
.modal-head {
  min-height: 48px;
  padding: 12px 14px;
  border-bottom-color: #f4f4f5;
  background: #ffffff;
}

.panel-title h2,
.modal-title h2 {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: 700;
}

.panel-meta {
  font-size: 12px;
  font-weight: 600;
}

.filter-block {
  gap: 8px;
  padding: 12px 14px 0;
}

.filter-block:last-child {
  padding-bottom: 14px;
}

.filter-label {
  font-size: 12px;
  font-weight: 600;
}

.filter-row {
  gap: 6px;
}

.filter-chip {
  min-height: 30px;
  border-color: #e4e4e7;
}

.filter-chip.is-active {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: #0f766e;
}

.filter-chip.is-active em {
  background: #0f766e;
}

.data-table th {
  padding: 10px 14px;
  background: #fafafa;
  font-size: 11px;
  font-weight: 650;
}

.data-table td {
  padding: 12px 14px;
}

.title-cell strong,
.doc-progress,
.deadline {
  font-weight: 650;
}

.status-badge,
.table-btn {
  min-height: 26px;
  font-size: 11px;
  font-weight: 600;
}

.status-badge.is-done,
.status-badge.is-progress {
  background: #ecfdf5;
  color: #0f766e;
}

.loading-state,
.empty-state {
  min-height: 220px;
  padding: 42px 20px;
}

.empty-state i {
  font-size: 26px;
}

.empty-state strong {
  font-size: 13px;
  font-weight: 650;
}

.pagination {
  padding: 12px 14px 14px;
}

.page-btn {
  min-width: 30px;
  height: 30px;
}

.page-btn.is-active {
  border-color: #0f766e;
  background: #0f766e;
}

.form-grid,
.modal-actions {
  padding-left: 18px;
  padding-right: 18px;
}

/* Font scale refinement */
.analysis-page {
  font-size: 12px;
}

.header-copy h1 {
  font-size: 16px;
}

.header-copy p,
.panel-meta,
.filter-label,
.date-text {
  font-size: 11.5px;
}

.panel-title h2,
.modal-title h2 {
  font-size: 14px;
}

.secondary-btn,
.primary-btn,
.text-btn,
.filter-chip,
.table-btn,
.status-badge,
.field,
.file-drop {
  font-size: 11.5px;
}

.title-cell strong,
.doc-progress,
.deadline {
  font-size: 12px;
}

.data-table td {
  font-size: 12px;
}`],
})
export class PageAnalysisComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public items: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 10;
    public loading: boolean = false;

    public keywordFilters: any[] = [];
    public selectedKeyword: string = '';
    public selectedStatus: string = '';
    public sourceFilter: string = '';
    public entryMode: string = '';

    public stats: any = { total_scraps: 0, total_docs: 0, done_docs: 0, rfp_docs: 0 };

    // 수동 등록 모달
    public showManualModal: boolean = false;
    public manualForm: any = { title: '', org_name: '', deadline: '', biz_type: '' };
    public manualFiles: File[] = [];
    public manualSubmitting: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.readEntryContext();
        await this.loadStats();
        await this.loadKeywords();
        await this.load();
        await this.service.render();
    }

    private readEntryContext() {
        const params = new URLSearchParams(window.location.search || '');
        this.sourceFilter = (params.get('source') || '').trim();
        this.entryMode = (params.get('entry') || '').trim();
    }

    public get proposalEntry(): boolean {
        return this.entryMode === 'proposal';
    }

    private async loadStats() {
        try {
            let params: any = {};
            if (this.sourceFilter) params.source = this.sourceFilter;

            let res = await wiz.call("stats", params);
            if (res.code === 200) this.stats = res.data;
        } catch { }
    }

    private async loadKeywords() {
        try {
            let params: any = {};
            if (this.sourceFilter) params.source = this.sourceFilter;

            let res = await wiz.call("keywords", params);
            if (res.code === 200) this.keywordFilters = res.data.keywords || [];
        } catch { }
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        try {
            let params: any = { page: this.page, dump: this.dump };
            if (this.selectedKeyword) params.keyword = this.selectedKeyword;
            if (this.selectedStatus) params.status = this.selectedStatus;
            if (this.sourceFilter) params.source = this.sourceFilter;

            let res = await wiz.call("list", params);
            if (res.code === 200) {
                this.items = res.data.rows || [];
                this.total = res.data.total || 0;
            }
        } catch { }

        this.loading = false;
        await this.service.render();
    }

    public async filterByKeyword(keyword: string) {
        this.selectedKeyword = this.selectedKeyword === keyword ? '' : keyword;
        this.page = 1;
        await this.load();
    }

    public async filterByStatus(status: string) {
        this.selectedStatus = this.selectedStatus === status ? '' : status;
        this.page = 1;
        await this.load();
    }

    public async clearFilter() {
        this.selectedKeyword = '';
        this.selectedStatus = '';
        this.page = 1;
        await this.load();
    }

    public openDetail(item: any) {
        const suffix = this.proposalEntry ? '?from=project' : '';
        this.service.href(`/analysis/${encodeURIComponent(item.notice_no)}${suffix}`);
    }

    public get totalPages(): number {
        return Math.ceil(this.total / this.dump) || 1;
    }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.load();
    }

    public get pageRange(): number[] {
        let pages: number[] = [];
        let start = Math.max(1, this.page - 2);
        let end = Math.min(this.totalPages, start + 4);
        start = Math.max(1, end - 4);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public getStatusLabel(status: string): string {
        const map: any = { none: '미분석', pending: '대기', processing: '분석중', done: '완료', partial: '부분완료' };
        return map[status] || status;
    }

    public getStatusColor(status: string): string {
        const map: any = {
            none: 'bg-stone-100 text-stone-500',
            pending: 'bg-amber-50 text-amber-600 border border-amber-200',
            processing: 'bg-blue-50 text-blue-600 border border-blue-200',
            done: 'bg-emerald-50 text-emerald-600 border border-emerald-200',
            partial: 'bg-orange-50 text-orange-600 border border-orange-200'
        };
        return map[status] || 'bg-stone-100 text-stone-500';
    }

    public getDday(deadline: string): number | null {
        if (!deadline) return null;
        try {
            let dt: Date;
            if (deadline.includes('-')) {
                dt = new Date(deadline);
            } else if (deadline.length >= 8) {
                let y = deadline.substring(0, 4);
                let m = deadline.substring(4, 6);
                let d = deadline.substring(6, 8);
                dt = new Date(`${y}-${m}-${d}`);
            } else {
                return null;
            }
            let now = new Date();
            now.setHours(0, 0, 0, 0);
            dt.setHours(0, 0, 0, 0);
            return Math.ceil((dt.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
        } catch {
            return null;
        }
    }

    public getDdayColor(days: number | null): string {
        if (days === null) return 'text-stone-400';
        if (days < 0) return 'text-stone-400';
        if (days <= 3) return 'text-red-500';
        if (days <= 7) return 'text-orange-500';
        if (days <= 14) return 'text-yellow-600';
        return 'text-emerald-600';
    }

    public getDdayText(days: number | null): string {
        if (days === null) return '-';
        if (days === 0) return 'D-Day';
        if (days > 0) return `D-${days}`;
        return `D+${Math.abs(days)}`;
    }

    public formatBudget(amount: number) {
        if (!amount) return '-';
        if (amount >= 100000000) return (amount / 100000000).toFixed(1) + '억원';
        if (amount >= 10000) return (amount / 10000).toFixed(0) + '만원';
        return amount.toLocaleString() + '원';
    }

    public formatDate(dt: string) {
        if (!dt || dt.length < 8) return '-';
        if (dt.includes('-')) return dt.substring(0, 10);
        return dt.substring(0, 4) + '-' + dt.substring(4, 6) + '-' + dt.substring(6, 8);
    }

    public async openManualModal() {
        this.manualForm = { title: '', org_name: '', deadline: '', biz_type: '' };
        this.manualFiles = [];
        this.showManualModal = true;
        await this.service.render();
    }

    public async deleteNotice(item: any) {
        if (!confirm(`"${item.title}" 공고를 삭제하시겠습니까?\n관련 문서와 파일이 모두 삭제됩니다.`)) return;
        try {
            let result = await wiz.call("delete_notice", { notice_no: item.notice_no });
            console.log('[deleteNotice] result:', JSON.stringify(result));
            if (result.code === 200) {
                await this.loadStats();
                await this.load();
            } else {
                alert('삭제 실패: ' + JSON.stringify(result));
            }
        } catch (e: any) {
            console.error('[deleteNotice] error:', e);
            alert('삭제 에러: ' + e.message);
        }
    }

    public async unscrapNotice(item: any) {
        if (!confirm(`"${item.title}" 공고의 스크랩을 해제하시겠습니까?\n분석 페이지에서 사라집니다.`)) return;
        try {
            let result = await wiz.call("unscrap", { notice_no: item.notice_no });
            console.log('[unscrapNotice] result:', JSON.stringify(result));
            if (result.code === 200) {
                await this.loadStats();
                await this.load();
            } else {
                alert('스크랩 해제 실패: ' + JSON.stringify(result));
            }
        } catch (e: any) {
            console.error('[unscrapNotice] error:', e);
            alert('스크랩 해제 에러: ' + e.message);
        }
    }

    public async closeManualModal() {
        this.showManualModal = false;
        await this.service.render();
    }

    public async onManualFileChange(event: any) {
        this.manualFiles = Array.from(event.target.files || []);
        await this.service.render();
    }

    public async submitManual() {
        if (!this.manualForm.title) {
            await this.service.modal.show({ title: '알림', message: '사업명을 입력해주세요.', cancel: false, action: '확인', actionBtn: 'default', status: 'warning' });
            return;
        }
        if (this.manualFiles.length === 0) {
            await this.service.modal.show({ title: '알림', message: 'RFP 파일을 첨부해주세요.', cancel: false, action: '확인', actionBtn: 'default', status: 'warning' });
            return;
        }

        this.manualSubmitting = true;
        await this.service.render();

        try {
            let formData = new FormData();
            formData.append('title', this.manualForm.title);
            formData.append('org_name', this.manualForm.org_name);
            formData.append('deadline', this.manualForm.deadline);
            formData.append('biz_type', this.manualForm.biz_type);
            for (let f of this.manualFiles) {
                formData.append('file', f);
            }

            console.log('[manual_create] url:', wiz.url('manual_create'));
            console.log('[manual_create] files:', this.manualFiles.length);
            let res = await fetch(wiz.url('manual_create'), { method: 'POST', body: formData });
            console.log('[manual_create] response status:', res.status);
            let data = await res.json();
            console.log('[manual_create] response data:', data);

            if (data.code === 200) {
                this.showManualModal = false;
                await this.loadStats();
                await this.load();
                this.service.href(`/analysis/${data.data.notice_no}`);
            } else {
                await this.service.modal.show({ title: '오류', message: data.data?.message || '등록 실패', cancel: false, action: '확인', actionBtn: 'default', status: 'error' });
            }
        } catch (e: any) {
            console.error('[manual_create] error:', e);
            await this.service.modal.show({ title: '오류', message: e.message || '등록 실패', cancel: false, action: '확인', actionBtn: 'default', status: 'error' });
        }

        this.manualSubmitting = false;
        await this.service.render();
    }
}

export default PageAnalysisComponent;